import React, { FC, useContext, useState, useEffect, useMemo } from 'react';
import { CarouselContext } from 'pure-react-carousel';
import clsx from 'clsx';
import { useConditionalPageContextSERP } from '../../hooks';

import { StyledCarouselBullets } from './CarouselBullets.style';

export const CarouselBullets: FC<{ slideCount: number }> = ({ slideCount }) => {
  const carouselContext = useContext(CarouselContext);
  const [currentSlide, setCurrentSlide] = useState(carouselContext.state.currentSlide);
  const [totalSlides, setTotalSlides] = useState(slideCount);
  const { pageVal } = useConditionalPageContextSERP();
  useEffect(() => {
    function onChange() {
      setCurrentSlide(carouselContext.state.currentSlide);
      setTotalSlides(carouselContext.state.totalSlides);
    }
    carouselContext.subscribe(onChange);
    return () => carouselContext.unsubscribe(onChange);
  }, [carouselContext]);

  const bulletCount = useMemo(() => {
    // If 1 or 0, don't need to display.
    if (totalSlides < 2) {
      return 0;
    }
    return totalSlides > 5 ? 5 : totalSlides;
  }, [totalSlides]);

  const activeBullet = useMemo(() => {
    let activeIndex = currentSlide;
    if (totalSlides > 5) {
      if (currentSlide > 1 && currentSlide < totalSlides - 2) {
        activeIndex = 2;
      } else if (currentSlide === totalSlides - 2) {
        activeIndex = 3;
      } else if (currentSlide === totalSlides - 1) {
        activeIndex = 4;
      }
    }
    return activeIndex;
  }, [totalSlides, currentSlide]);

  const bulletsList = useMemo(() => {
    const bList: { id: string; active: boolean }[] = [];
    for (let i = 0; i < bulletCount; i++) {
      bList.push({ id: `bullet-${i}`, active: i === activeBullet });
    }
    return bList;
  }, [bulletCount, activeBullet]);

  return (
    <StyledCarouselBullets className={clsx('carousel-bullets')} bulletCount={bulletCount} pageVal={pageVal}>
      {bulletsList?.map((item, index) => {
        return <div className={clsx('bullet', item.active ? 'active' : '')} key={`slide-bullet-${index}`}></div>;
      })}
    </StyledCarouselBullets>
  );
};
